module.exports = __webpack_public_path__ + "static/img/pars3.62e84d37.png";